import axios from "axios";

export const server = axios.create({ baseURL: "https://pets-api-7k0f.onrender.com" }); 